import { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Container from "components/__reusable/Container";
import Calendar from "components/__reusable/Calendar";
import { getPublishedPictureSummarizationByDate } from "services/summarizationServices";
import { PICTURES_SUMMARIZATION_PATH } from "router/pathName";
import { SummarizationByDate } from "types/Summarization";

const PublishedPictureCalendar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [summaries, setSummaries] = useState<SummarizationByDate[]>([]);

  const fetchStatus = async () => {
    try {
      const startDate = new Date(currentMonth);
      startDate.setDate(1);
      startDate.setHours(0, 0, 0, 0);
      const endDate = new Date(currentMonth);
      endDate.setMonth(endDate.getMonth() + 1);
      endDate.setDate(0);
      endDate.setHours(23, 59, 59, 999);

      const summaries = await getPublishedPictureSummarizationByDate(
        startDate.toISOString(),
        endDate.toISOString()
      );
      setSummaries(summaries);
    } catch (e) {
      console.error(e);
    }
  };

  const renderElement = () => {
    const renderedElements: {
      [key: string]: ReactNode;
    } = {};
    for (let summary of summaries) {
      renderedElements[summary.date] = (
        <button
          type="button"
          className="group flex h-full min-h-[72px] w-full flex-col items-center justify-center rounded transition-colors hover:bg-primary/5 focus:outline-none focus:ring-2 focus:ring-primary/40"
          onClick={() => handleSummaryClick(summary.date)}
        >
          <img
            className="w-8 max-w-full"
            src="/images/sakura.svg"
            alt="sakura"
          />
          <p className="text-sm text-center text-primary underline group-hover:no-underline">
            {summary.number_published_picture} {t("_home._images")}
          </p>
        </button>
      );
    }
    return renderedElements;
  };

  const handleSummaryClick = (date: string) => {
    navigate(`${PICTURES_SUMMARIZATION_PATH}?date=${date}`);
  };

  useEffect(() => {
    fetchStatus();
  }, [currentMonth]);

  return (
    <Container>
      <h2 className="text-xl text-center font-bold">配信カレンダー</h2>
      <Calendar
        renderedElement={renderElement()}
        placeHolderElement={
          <div className="w-full invisible">
            <img className="max-w-1/2" src="/images/sakura.svg" alt="sakura" />
            <p className="text-sm text-center">0 {t("_home._images")}</p>
          </div>
        }
        onMonthChange={(date) => setCurrentMonth(date)}
      />
    </Container>
  );
};

export default PublishedPictureCalendar;
